/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";

export const spin = emotion.keyframes`
  0% { 
    transform: rotate(0deg);
  }
  30% {
   transform: rotate(300deg);
  }
  100% { transform: rotate(360deg); }
`;
export const loader = emotion.css`
	border: 8px solid transparent;
	border-radius: 50%;
	border-top: 8px solid #3498db;
	border-bottom: 8px solid #3498db;
	border-right: 8px solid #3498db;
	width: 30px;
	height: 30px;
	animation: ${spin} 2s linear infinite;
`;

type Props = {
    message?: string
    overlay?: boolean
    absolute?: boolean
}

export const Loader = (props: Props) => {
    if (props.overlay)
        return <div
            id={'loader'}
            className="match_width match_height full_screen"
            style={{background: COLORS.grays_05}}>
            <Spinner message={props.message}/>
        </div>;

    if (props.absolute)
        return <div
            id={'absolute-loader'}
            className="match_width match_height"
            style={{background: '#dedede50', zIndex: 999999, position: 'absolute', top: 0, left: 0}}>
            <div
                id={'absolute-loader-inner'}
                style={{height: '100%'}}
            >
                <Spinner message={props.message}/>
            </div>
        </div>;

    return <Spinner message={props.message}/>

}

const Spinner = ({message}: { message?: string }) => (
    <div className="ll_h_c match_height fill" style={{position: "absolute", background: COLORS.grays_05}}>
        <div className="ll_v_c match_width">
            <div className={`loader`}/>
            <div style={{marginTop: '20px', color: '#f9f9f9'}}>{message || "Loading..."}</div>
        </div>
    </div>
);
